import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RedirectService {
  redirectToIndexWithPostParams(action,params: any) {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = action;  // Change the URL as needed

    // Create hidden input fields for each parameter
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        // alert('post params key: ' + key + ' value: ' + params[key]);
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = params[key];
        form.appendChild(input);
      }
    }

    // Append the form to the body and submit it
    document.body.appendChild(form);
    form.submit();
  }
}
